import React, {useState} from 'react';
import {Accordion} from '../../Accordion/Accordion';
import {ContentWrapper} from './FileMetaDataTabDisclaimer.style';
import {t} from 'i18next';
import {generateIdentifier} from '../../../utils/IdentityUtils';
import EventEmitter from 'events';
import {FileMetaDataDialog_changeDisclaimer} from '../../../init/events';
import {DisclaimerPicker} from '../../DisclaimerPicker/DisclaimerPicker';
import {DisclaimerDTO} from '../../../models/dto/DisclaimerDTO';
import {NO_DISCLAIMER_KEY} from '../../../init/constants';
import {TemplatePropertySettings} from '../../../models/TemplatePropertySettings';
import {isMandatoryComponent, isVisibleComponent} from '../../../utils/TemplateUtils';
import {
    STORAGE_OBJECT_OBJECT_METADATA,
    STORAGE_OBJECT_OBJECT_METADATA_DISCLAIMER
} from '../../../init/storage_object_constants';
import {config} from '../../../init/config';
import {Valid} from '../../validation/Valid';
import {isValidText} from '../../../utils';

export interface FileMetaDataTabDisclaimerProps {
    readonly templatePropertySettings: Map<string, TemplatePropertySettings>;
    readonly disclaimerData: DisclaimerDTO[];
    readonly disclaimer?: string;
    readonly watermark: boolean;
    readonly eventEmitter: EventEmitter;
}

/**
 * @name FileMetaDataTabDisclaimer
 * @description
 * The dialog to add the metadata of a newly created file or edited file - Metadata Tabs
 */
export const FileMetaDataTabDisclaimer: React.VFC<FileMetaDataTabDisclaimerProps> = (props) => {
    const [disclaimerInput, setDisclaimerInput] = useState<string>(props.disclaimer ?? NO_DISCLAIMER_KEY);
    const [watermarkInput] = useState<boolean>(props.watermark ?? false);

    const handleChangeDisclaimer = (disclaimer: string) => {
        setDisclaimerInput(disclaimer);
        props.eventEmitter.emit(FileMetaDataDialog_changeDisclaimer, disclaimer);
    };

    return (
        <ContentWrapper id={generateIdentifier()}>
            {(config.DISCLAIMER_ENABLED && isVisibleComponent(STORAGE_OBJECT_OBJECT_METADATA, props.templatePropertySettings)
                    && isVisibleComponent(STORAGE_OBJECT_OBJECT_METADATA_DISCLAIMER, props.templatePropertySettings)) &&
                <Accordion accordionHeadline={t('CREATE_EDIT_FILE_DIALOG_ACCORDION_TITLE_DISCLAIMER')}
                           startOpen>
                    <Valid
                        isValid={(isMandatoryComponent(STORAGE_OBJECT_OBJECT_METADATA_DISCLAIMER, props.templatePropertySettings) ? isValidText(disclaimerInput) : true)}
                        message={t('ERROR_DISCLAIMER_ID_MISSING')}>
                        <DisclaimerPicker dataSource={props.disclaimerData}
                                          disclaimer={disclaimerInput}
                                          watermark={watermarkInput}
                                          onChange={handleChangeDisclaimer}/>
                    </Valid>
                </Accordion>
            }
        </ContentWrapper>
    );
}